module.exports = __webpack_public_path__ + "static/media/image034.6b676b38.jpg";